import EmptySection from '@/components/EmptySection';
import Loader from '@/components/Loader';
import StudentViewSection from '@/components/StudentViewSection';
import Constants from '@/Constants';
import { useContentLanguageChange } from '@/hooks/useContentLanguageChange';
import { analyticsService, FlowEvents } from '@/services/AnalyticsService';
import { ApplicationState } from '@/store';
import { getFavoriteListClear, getFavoriteListRequest } from '@/store/favorite/actions';
import { Favorite } from '@/store/favorite/types';
import { contentsClear } from '@/store/item/action';
import { coursesClear } from '@/store/list/action';
import { programsClear } from '@/store/program/action';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'underscore';
import './style.scss';

const FavoritesPage: React.FC = () => {
    const FAVORITES_VIEW_TYPE = 'listFavoriteStudentView';

    const dispatch = useDispatch();

    const {
        favoriteList,
        strings,
        loadingFavorites,
        hasCourseOrContentOrProgramInFavoriteList,
        courseAndContentAndProgramIsLoadingOrEmpty,
    } = useSelector((state: ApplicationState) => {
        const hasCourseOrContentOrProgramInFavoriteList: boolean =
            state.favorite.favoriteList.length > 0 &&
            _.some(
                state.favorite.favoriteList,
                (item: Favorite) =>
                    [Constants.entityTypes.CONTENT, Constants.entityTypes.COURSE, Constants.entityTypes.PROGRAM].indexOf(item.contentType) !== -1,
            );

        const myCourses = state.lists.listData[FAVORITES_VIEW_TYPE];
        const myContents = state.itens.listData[FAVORITES_VIEW_TYPE];
        const myPrograms = state.program.listData[FAVORITES_VIEW_TYPE];

        const courseAndContentAndProgramIsLoadingOrEmpty =
            !myCourses.loading &&
            myCourses.total === 0 &&
            !myContents.loading &&
            myContents.total === 0 &&
            !myPrograms.loading &&
            myPrograms.total === 0;

        return {
            favoriteList: state.favorite.favoriteList,
            strings: state.locale.data,
            loadingFavorites: state.favorite.loading,
            courseAndContentAndProgramIsLoadingOrEmpty,
            hasCourseOrContentOrProgramInFavoriteList,
        };
    });

    useEffect(() => {
        analyticsService.logEvent(FlowEvents.MY_FAVORITES);
    }, []);

    useContentLanguageChange({
        unmountChange: () => {
            dispatch(getFavoriteListClear());
            dispatch(getFavoriteListRequest());
            dispatch(coursesClear());
            dispatch(contentsClear());
            dispatch(programsClear());
        },
    });

    return (
        <div className="favorites">
            {hasCourseOrContentOrProgramInFavoriteList && <StudentViewSection hideTitle={true} viewType={FAVORITES_VIEW_TYPE} />}

            {!loadingFavorites && (!hasCourseOrContentOrProgramInFavoriteList || courseAndContentAndProgramIsLoadingOrEmpty) && (
                <div className="empty-section-container">
                    <EmptySection iconName={Constants.icons.SMS_FAILED} message={strings.EMPTY_SECTION_MESSAGE} />
                </div>
            )}
            {loadingFavorites && favoriteList.length === 0 && <Loader />}
        </div>
    );
};
export default FavoritesPage;
